import { useState } from "react";
import { BASE_URL } from '../apiConfig';

export default function ProductImageGallery({ images, productName }) {
  const [selectedImage, setSelectedImage] = useState(0)

  return (
    <div className="space-y-4">
      <div className="aspect-square overflow-hidden rounded-2xl bg-gray-100">
        <img
          src={`${BASE_URL}/storage/${images[selectedImage]?.image || images[0]?.image}`}
          alt={productName}
          width={600}
          height={600}
          className="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
          priority
        />
      </div>

      {images.length > 1 && (
        <div className="flex space-x-3 overflow-x-auto p-2">
          {images.map((image, index) => (
            <button
              key={image.id}
              onClick={() => setSelectedImage(index)}
              className={`flex-shrink-0 cursor-pointer overflow-hidden rounded-lg transition-all duration-200 ${
                selectedImage === index ? "ring-2 ring-[var(--color-primary-500)] ring-offset-2" : "hover:opacity-75"
              }`}
            >
              <img
                src={`${BASE_URL}/storage/${image.image}`}
                alt={`${productName} ${index + 1}`}
                width={80}
                height={80}
                className="h-20 w-20 object-cover"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
